module.exports = __webpack_public_path__ + "static/media/album.77fa00df.svg";